import { createLocale } from "./createLocale";

export const ga = createLocale({
  header: {
    title: "Téigh domhanda. $2 an Short. Aon teanga!",
    subtitle: "🔥Íoc as torthaí amháin – ó $0.089 go $0.009 sa soicind🔥",
  },
  steps: {
    uploadVideo: "Uaslódáil Físeán",
    selectLanguages: "Roghnaigh Teangacha",
    conversionResult: "Tiontú agus Toradh",
  },
  upload: {
    dragAndDrop: "Tarraing agus scaoil do chomhad físe anseo",
    orClickToSelect: "nó cliceáil chun roghnú",
    supportedFormats: "Formáidí tacaithe: MP4, AVI, MOV, MKV, WebM",
    maxFileSize: "• Uasmhéid comhaid: 200 MB",
    maxDuration: "• Fad uasta: 30 soic",
    chooseFile: "Roghnaigh comhad",
    selectedFile: "Comhad roghnaithe:",
    size: "Méid:",
    fileTypeError: "Roghnaigh comhad físe le do thoil",
    fileSizeError: "Sáraíonn méid an chomhaid ({size} MB) an teorainn uasta de 200 MB",
    durationError: "Sáraíonn fad an fhíseáin ({duration} soic) an teorainn uasta de 30 soic",
    fileReadError: "Ní féidir an comhad físe a léamh. Bain triail as comhad eile.",
  },
  languages: {
    sourceAudioLanguage: "Teanga fuaime foinse",
    targetAudioLanguage: "Teanga fuaime sprice",
    selectLanguage: "Roghnaigh teanga...",
  },
  conversion: {
    replaceAudio: "Clónaigh mo ghuth",
    uploadVideoAndSelectLanguages: "Uaslódáil físeán agus roghnaigh teangacha chun leanúint ar aghaidh",
  },
  nav: {
    blog: "Blag",
  },
  footer: {
    privacyPolicy: "Polasaí Príobháideachais",
    termsOfUse: "Téarmaí Úsáide",
  },
  languageOptions: {
    ru: "Rúisis",
    en: "Béarla",
    es: "Spáinnis",
    fr: "Fraincis",
    de: "Gearmáinis",
    it: "Iodáilis",
    pt: "Portaingéilis",
    pl: "Polainnis",
    zh: "Sínis",
    ja: "Seapáinis",
    ko: "Cóiréis",
    ar: "Araibis",
    bg: "Bulgáiris",
    hr: "Cróitis",
    cs: "Seicis",
    da: "Danmhairgis",
    nl: "Ollainnis",
    et: "Eastóinis",
    fi: "Fionlainnis",
    el: "Gréigis",
    hu: "Ungáiris",
    ga: "Gaeilge",
    lv: "Laitvis",
    lt: "Liotuáinis",
    mt: "Máltais",
    ro: "Rómáinis",
    sk: "Slóvaicis",
    sl: "Slóivéinis",
    sv: "Sualainnis",
  },
});
